<template lang="pug">
  aiq-tabs(v-model="activeTab" class="campaign-tabs" type="card" @tab-click="onTabChange")
      aiq-tab-pane(:label="$t('settings_tab.campaign_tab.manage.in_progress')" name="pending")
        CustomerCampaign(:executed="false",
                         :grouped="grouped",
                         :customer="customer",
                         :CampaignList="campaignList"
                         :CustomerList="customerCampaigns"
                         :allCustomerCampaigns="allCustomerCampaigns"
                         @refresh="init"
                         )
      aiq-tab-pane(:label="$t('settings_tab.campaign_tab.manage.completed')" name="completed")
        CustomerCampaign(:executed="true",
                         :customer="customer",
                         :grouped="executedGrouped",
                         :CampaignList="campaignList"
                         :CustomerList="customerCampaignsExecuted"
                         @refresh="init"
                         )
      aiq-tab-pane(:label="$t('settings_tab.campaign_tab.manage.incomplete')" name="incomplete")
        CustomerCampaign(:executed="true",
                         :customer="customer",
                         :grouped="incompletedGrouped",
                         :CampaignList="campaignList"
                         :CustomerList="customerCampaignsIncomplete"
                         @refresh="init"
                         )

</template>
<script>
import get from 'lodash/get';
import groupBy from 'lodash/groupBy';
import forEach from 'lodash/forEach';
import some from 'lodash/some';
import every from 'lodash/every';
import CustomerCampaign from './CustomerCampaign.vue';

const PAGE_LIMIT = 100;
export default {
  name: 'CampaignManage',
  components: {
    CustomerCampaign,
  },
  props: {
    customer: {
      type: Object,
      default: () => {},
    },
    conversation: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    async customer() {
      await this.init();
    },
  },
  data() {
    return {
      showEditor: false,
      campaignList: [],
      customerCampaigns: [],
      customerCampaignsExecuted: [],
      customerCampaignsIncomplete: [],
      grouped: {},
      executedGrouped: {},
      incompletedGrouped: {},
      activeTab: 'pending',
      allCustomerCampaigns: {},
    };
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      const params = {
        limit: PAGE_LIMIT,
      };
      try {
        const response = await this.$store.dispatch(
          'campaign/getCampaignList',
          [params, true],
        );
        const campaignList = get(response, 'data.models', []);
        const channel = get(this.conversation, 'channel', '');

        this.campaignList = campaignList.filter(e => e.channel === channel);

        const Campaigns = await this.getCustomerCampaign();

        const { pending, executed, incomplete } = this.groupCampaignsBasedOnStatus(Campaigns);

        this.customerCampaigns = pending;
        this.customerCampaignsExecuted = executed;
        this.customerCampaignsIncomplete = incomplete;

        this.grouped = groupBy(this.customerCampaigns, (item) => item.created_at);
        this.executedGrouped = groupBy(this.customerCampaignsExecuted, (item) => item.created_at);
        this.incompletedGrouped = groupBy(this.customerCampaignsIncomplete, (item) => item.created_at);

        this.allCustomerCampaigns = {
          pending: this.customerCampaigns,
          executed: this.customerCampaignsExecuted,
        };
      } catch (error) {
        this.$aiq.notify.error('Error fetching campaign');
      }
    },

    /**
     * Groups customer campaigns based on their status
     * @param {Array} allCampaigns - all customer campaigns
     * @returns {Object} an object containing the grouped customer campaigns
     * @property {Array} pending - customer campaigns that are pending
     * @property {Array} executed - customer campaigns that have been executed
     * @property {Array} incomplete - customer campaigns that are incomplete (deleted or terminated)
     */
    groupCampaignsBasedOnStatus(allCampaigns) {
      const pending = [];
      const executed = [];
      const incomplete = [];

      // Group by created_at
      const groups = groupBy(allCampaigns, 'created_at');

      // Iterate each group
      forEach(groups, (group) => {

        // Check incomplete first
        const hasIncomplete = some(group, c =>
          c.deleted_at || c.terminated,
        );

        if (hasIncomplete) {
          incomplete.push(...group);
          return;
        }

        // Check if all executed
        const allExecuted = every(group, c =>
          c.executed === true,
        );

        if (allExecuted) {
          executed.push(...group);
        } else {
          pending.push(...group);
        }
      });

      return { pending, executed, incomplete };
    },

    async getCustomerCampaign() {
      const customerCampaigns = await this.$store.dispatch(
        'campaign/getCustomerCampaignList',
        {
          customerId: this.customer.id,
        },
      );
      return get(customerCampaigns, 'data.models', []);
    },

    onTabChange({paneName: key}) {
      if (this.activeTab === key) return;
      this.activeTab = key;
    },

  },
};
</script>